





















import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Action, State } from 'vuex-class'
import { AnalysisReport, Metadata, RuleStatus, RuleSet } from '@/modules/seo/types'
import Rule from '@/modules/seo/components/analysis/Rule.vue'
import ReadabilityRule from '@/modules/seo/components/analysis/ReadabilityRule.vue'
import { Rule as RuleType } from '@/modules/seo/types'
import { Prop } from 'vue-property-decorator';

/**
 * Analisis SEO
 */
@Component({
    components: { Rule, ReadabilityRule },
})
export default class SEOAnalysis extends Vue {

    @State(state => state.seo.currentMetadata)
    public metadata: Metadata

    @State(state => state.seo.currentAnalysisReport)
    public report: AnalysisReport

    @Prop({type: Boolean, default: false})
    public disabled: boolean

    @Prop({type: String, default: ''})
    public disableText: string

    /**
     * Ejecuta un análisis
     */
    @Action('seo/loadSEOAnalysisReport')
    public analyze: () => void

    private ruleStatusPriority: {[key: string]: number} = {
        [RuleStatus.Pass]: 0,
        [RuleStatus.Warning]: 1,
        [RuleStatus.Fail]: 2,
    }

    get readabilityRule (): RuleType {
        return this.report.rules.get('content.readability', new RuleType())
    }

    public get rules () {
        return _.sortBy(
            this.report.rules.rules,
            (r: RuleType) => this.ruleStatusPriority[r.status],
        )
    }
}
